export default __webpack_public_path__ + "static/media/3.35916041.jpg";